import './App.css';
import Routes from "./app/Routes";

function App() {
  return (
    <Routes/>
  );
}

export default App;
